// Centralized auth utilities
export function getRedirectUrl(path: string = '/generate'): string {
  // In production, always use the production URL
  if (window.location.hostname === 'bardus.ai' || window.location.hostname === 'www.bardus.ai') {
    return `https://bardus.ai${path}`;
  }
  
  // In development, use the current origin
  return `${window.location.origin}${path}`;
}